module.exports = __webpack_public_path__ + "carousel-white-2.5ff1d9ce8d2ab2705c14c31f2aa81347.jpg";